if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', class ProductTabs extends HTMLElement {
    constructor() {
      super();

      this.productTabs = document.querySelector('product-tabs');

      this.elements = {
        headingsListItem: this.productTabs.querySelectorAll('.product-tabs__heading-item'),
        headings: this.productTabs.querySelectorAll('.product-tabs__heading'),
        contentListItems: this.productTabs.querySelectorAll('.product-tabs__content-item'),
      }

      this.elements.headings.forEach((el, i) => {
        el.addEventListener('click', (e) => this.toggleTabs(e));
      });
    }

    toggleTabs(e) {
      e.preventDefault();

      let headingIndex = [...this.elements.headingsListItem].indexOf(e.currentTarget.parentElement);

      this.elements.headingsListItem.forEach((el, i) => {
        el.classList.remove('product-tabs__heading-item--active');
      });

      e.currentTarget.parentElement.classList.add('product-tabs__heading-item--active');

      this.elements.contentListItems.forEach((el, i) => {
        el.classList.remove('product-tabs__content-item--active');
      });

      this.elements.contentListItems[headingIndex].classList.add('product-tabs__content-item--active');
    }
  });
}
